module.exports = __webpack_public_path__ + "img/lottery_960.e465d207.png";